import setupParallax from '@/utils/setupParallax';

export default function(dom, opts) {
	let options = {
		baseClass: 'revealleadtext',
		...opts
	};

	const wrapper = dom.querySelector(`.${options.baseClass}__wrapper`);
	const scaleBox = dom.querySelector(`.${options.baseClass}__scalebox`);
	const updateRevealParallax = ({factor, factorReversed}) => {
		const maxScale = Math.ceil(wrapper.clientHeight / scaleBox.clientHeight);
		scaleBox.style.transform = `scale(${factorReversed * maxScale})`;
	};

	setupParallax(dom, updateRevealParallax, true);
}
